import { AnketaDescriptionModal } from './AnketaDescriptionModal';

export default AnketaDescriptionModal;